<template>
  <div class="d-flex align-items-center gap-5">
    <div class="w-50">
      <nuxt-img src="/images/pages/organisme-formation/nos-sessions.jpeg"></nuxt-img>
    </div>
    <div class="w-50">
      <h2 class="mb-60">
        <span class="span-background-red">Nos prochaines sessions</span>
      </h2>
      <p class="pb-3">
        Découvrez nos prochaines dates de Formation en présentiel ou à distance en visio-conférence.
      </p>
      <p>
        Nos sessions inter-entreprises en présentiel se déroulent dans les villes suivantes : <br><br>
        <span class="fw-bold">Occitanie :</span> Toulouse, Perpignan, Montpellier, Nîmes <br>
        <span class="fw-bold">Nouvelle -Aquitaine :</span> Bordeaux, Bayonne, Poitiers, Pau, La Rochelle <br>
        <span class="fw-bold">Auvergne-Rhône-Alpes :</span> Clermont-Ferrand, Saint-Etienne, Lyon, Grenoble <br>
        <span class="fw-bold">P.A.C.A. : </span> Avignon, Marseille, Aix-en-Provence, Toulon, Nice, Sophia-Antipolis <br>
        <span class="fw-bold">Corse : </span> Ajaccio, Bastia. <br><br>
        Nous organisons également des sessions en intra-entreprise dans toute la France.
      </p>
      <div>
        <a class="btn-rouge-outline" :href="pdf" target="_blank"><i class="fa-solid fa-newspaper"></i> Télécharger le calendrier</a>
      </div>
    </div>
  </div>
</template>
<script setup>
import axios from 'axios';

const pdf = ref('');

onMounted(async () => {
  try {
    const response = await axios({
      method: 'post',
      url: 'https://ws2-gbbu02.graphibox.eu/EpDirectories.ws',
      data: {
        pKey: 'EmPA5d6sdse5z6ldfjPAEhazozp5ksJEZkzn872',
        pFct: 'GetDirectories',
        pIdCat: '69',
      },
    });
    console.log("response data : ", response.data);
    const files = response.data[1];
    pdf.value = `https://cdn-gbbu02.graphibox.eu/pub/${files.siteIdD}/medias/directories/${files.idD}/${files.file1D}`;
  } catch (error) {
    console.error('Erreur lors du chargement des données :', error);
  }
});
</script>
<style scoped>
h2 {
  font-family: Nunito;
  font-size: 50px;
  font-style: normal;
  font-weight: 600;
  line-height: 111.5%;
  /* 61.325px */
  letter-spacing: -0.825px;
  text-transform: uppercase;
}

p {
  font-family: Inter;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 144%;
  /* 25.92px */
  letter-spacing: 0.72px;
}

a {
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 135%;
  /* 27px */
  letter-spacing: 0.8px;
}

@media only screen and (min-width: 300px) and (max-width: 768px) {
  .d-flex {
    flex-direction: column;
    width: 100%;
    padding: 10px 10px;
  }

  h2 {
    font-size: 1.469rem !important;
  }

  .w-50 {
    width: 90% !important;
  }
}

/* Pour les appareils entre 768px et 991px de large (tablettes en mode paysage) */
@media only screen and (min-width: 769px) and (max-width: 991px) {
}

/* Pour les appareils entre 992px et 1199px de large (tablettes en mode portrait et ordinateurs portables) */
@media only screen and (min-width: 992px) and (max-width: 1199px) {
}

/* Pour les appareils de 1200px de large et plus (ordinateurs de bureau) */
@media only screen and (min-width: 1200px) {
}
</style>